"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composedEndpoint = function (endpoint, payload) {
    if (payload == null) {
        return endpoint;
    }
    var params = new URLSearchParams(payload);
    return endpoint + '?' + params;
};
var urlUtils = {
    composedEndpoint: composedEndpoint
};
exports.default = urlUtils;
